<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-toolbar class="custom-toolbar grey-border-top">
  <ion-searchbar
    #productSearch
    mode="ios"
    [(ngModel)]="searchTerm"
    [placeholder]="'esim.product_search.search_placeholder' | translate"
    (ionInput)="filterProducts($event)"
    (keyup.enter)="filterProductsOnEnter()"
    (ionClear)="onSearchClear()"
  >
  </ion-searchbar>
</ion-toolbar>

<ion-content>
  <ion-grid
    *ngIf="noData && !isLoading && !hasError; else showList"
    class="ion-text-center v-center"
  >
    <ion-row>
      <ion-col size="12">
        <ion-label class="fs-3 font500 text-color">{{
          "esim.product_search.no_results" | translate
        }}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ng-template #showList>
    <ion-list class="ion-list-transparent-bg-color">
      <ion-item
        lines="inset"
        class="ion-justify-content-start ion-no-padding ion-item-transparent-bg-color"
        *ngFor="let product of productList"
        (click)="selectProduct(product)"
      >
        <ion-icon
          name="globe-outline"
          slot="start"
          class="global-icon card-secondary-text-color"
        ></ion-icon>
        <ion-label>
          <p class="fs-4 font600 product-name product-container paragraph-primary-text-color line-1-clip">
            {{ product.country || product.title || product.name }}
          </p>
          <div class="d-flex ion-justify-content-between">
            <p
              class="fs-2 font500 product-subtitle paragraph-secondary-text-color ion-no-margin"
            >
              {{ product.title || product.subTitle || product.description || product.region || (product.currency && product.price ? (product.currency + ' ' + product.price) : '') }}
            </p>
          </div>
        </ion-label>
      </ion-item>
    </ion-list>

    <div *ngIf="productList.length <= 0 && isLoading">
      <ion-list class="ion-list-transparent-bg-color">
        <ion-item
          *ngFor="let item of [0, 1, 2, 3, 4, 5, 6, 7]"
          class="ion-item-transparent-bg-color"
        >
          <ion-label>
            <h3>
              <ion-skeleton-text
                animated
                style="width: 80%; height: 16px"
              ></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text
                animated
                style="width: 50%"
              ></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>

    <app-inline-generic-error *ngIf="hasError"></app-inline-generic-error>

    <ion-infinite-scroll
      [disabled]="noData || hasError"
      (ionInfinite)="getNextPage($event)"
    >
      <ion-infinite-scroll-content loadingSpinner="crescent">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ng-template>
</ion-content>
